/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to revoke cross-tenant roles from users
 * @export
 * @interface RevokeCrossTenantRolesRequest
 */
export interface RevokeCrossTenantRolesRequest {
    /**
     * ID of the tenant relationship
     * @type {string}
     * @memberof RevokeCrossTenantRolesRequest
     */
    relationshipId: string;
    /**
     * List of user IDs to revoke roles from
     * @type {Array<string>}
     * @memberof RevokeCrossTenantRolesRequest
     */
    userIds: Array<string>;
    /**
     * Reason for the role revocation
     * @type {string}
     * @memberof RevokeCrossTenantRolesRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the RevokeCrossTenantRolesRequest interface.
 */
export function instanceOfRevokeCrossTenantRolesRequest(value: object): value is RevokeCrossTenantRolesRequest {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    return true;
}

export function RevokeCrossTenantRolesRequestFromJSON(json: any): RevokeCrossTenantRolesRequest {
    return RevokeCrossTenantRolesRequestFromJSONTyped(json, false);
}

export function RevokeCrossTenantRolesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevokeCrossTenantRolesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'userIds': json['userIds'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function RevokeCrossTenantRolesRequestToJSON(json: any): RevokeCrossTenantRolesRequest {
    return RevokeCrossTenantRolesRequestToJSONTyped(json, false);
}

export function RevokeCrossTenantRolesRequestToJSONTyped(value?: RevokeCrossTenantRolesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'userIds': value['userIds'],
        'reason': value['reason'],
    };
}

